import request from '@/utils/request'

// 查询角色等级配置分页
export function getRoleLevelList(data) {
  return request({
    url: '/biz/admin/community/role/level/config/page',
    method: 'post',
    data: data
  })
}

// 查询角色等级配置列表
export function getRoleLevelAllList(data) {
  return request({
    url: '/biz/admin/community/role/level/config/list',
    method: 'post',
    data: data
  })
}

// 保存角色等级配置（新增/更新）
export function saveRoleLevel(data) {
  return request({
    url: '/biz/admin/community/role/level/config/save',
    method: 'post',
    data: data
  })
}

// 删除角色等级配置
export function deleteRoleLevel(data) {
  return request({
    url: '/biz/admin/community/role/level/config/delete',
    method: 'post',
    data: data
  })
}

// 获取角色等级配置详情
export function getRoleLevelDetail(params) {
  return request({
    url: '/biz/admin/community/role/level/config/detail',
    method: 'get',
    params: params
  })
}

// 生成角色等级二维码
export function getRoleQrcode(data) {
  return request({
    url: '/biz/admin/community/role/qrcode/generate',
    method: 'get',
    params: data
  })
}